import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

interface ITextInputProps extends InputProps {
  value?: string
  placeholder: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const TextInput = ({
  value, placeholder, onChange, className, ...rest
}: ITextInputProps) => (
  <input
    value={value}
    onChange={onChange}
    className={classNames(styles.textInput, className)}
    placeholder={placeholder}
    {...rest}
  />
);

export default TextInput;
